import { memo } from 'react';

import { AnnouncementBody, type AnnouncementBodyProps } from './AnnouncementBody';
import { type AnnouncementSize, announcementSize } from './announcementSize';

export type AnnouncementBannerProps = Omit<AnnouncementBodyProps, 'collapseButtonRef' | 'onCollapse'> & {
  size?: AnnouncementSize;
};

export const AnnouncementBanner = memo(({ className, size = 'fluid', ...props }: AnnouncementBannerProps) => {
  return (
    <div className={announcementSize({ className, size })} data-testid="ANNOUNCEMENT_BANNER">
      <AnnouncementBody {...props} className="flex w-full items-start gap-2 rounded-12 p-3" />
    </div>
  );
});

AnnouncementBanner.displayName = 'AnnouncementBanner';
